module.exports = __webpack_public_path__ + "img/eligibility-arrow.e1a8908d.svg";